import { render } from "./WeddingFooter.vue?vue&type=template&id=5c6bb5f5&ts=true"
import script from "./WeddingFooter.vue?vue&type=script&lang=ts"
export * from "./WeddingFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__